import apiClient from '@/plugins/apiClient'
let basePath = "/byd/contests/partyconbyd";

export default {
     namespaced: true,
     state:{
          errors: {},
          message: null,
          success: null,
          result: null,
     },
     getters:{
          message: state => state.message,
          errors: state => state.errors,
          success: state => state.success,
          result: state => state.result,
     },
     mutations:{
        error(state, err) {
            console.log('mutation error',err);
            state.success = null
            state.result = null
            state.errors = err.response.data.errors
            state.message = err.response.data.message
        },
        success(state, resp) {
            console.log('mutation success',resp);
            state.success = true
            state.errors = {}
            state.message = null
            state.result = resp.data
        },
        reset(state) {
            state.success = null
            state.errors = {}
            state.message = null
            state.result = null
        }
          
     },
     actions:{
        reset({commit}){
            commit('reset')
        },
        playCode({commit},data){
            return new Promise((resolve, reject) => {
                console.log('playCode: ', data)
                apiClient.post(basePath+"/play-code", data).then(resp => {
                        resolve(resp);
                        commit('success', resp.data);
                    })
                    .catch(err => {
                        console.log('playCode ERROR', err)
                        commit('error', err);
                        reject(err);
                    });
            })
        },
     }
}